import React from "react";
import SubHeading from "./SubHeading";

const RecentComments = () => {
  return (
    <>
      {/* BLOCK */}
      <div className="p-4 md:p-0 mb-6">
        <SubHeading text="recent comments" color="black" />

        {/* Comments */}
        <div className="">
          {/* Comment 1 */}
          <div className="text-sm pt-5">Mary Dill on <span className="text-gray-900 italic font-semibold"> Another Big Apartment Project Slated for Broad Ripple Company</span></div>
          <div className="text-sm pt-5">Mary Dill on <span className="text-gray-900 italic font-semibold"> Another Big Apartment Project Slated for Broad Ripple Company</span></div>
          <div className="text-sm pt-5">Mary Dill on <span className="text-gray-900 italic font-semibold"> Another Big Apartment Project Slated for Broad Ripple Company</span></div>
          <div className="text-sm pt-5">Mary Dill on <span className="text-gray-900 italic font-semibold"> Another Big Apartment Project Slated for Broad Ripple Company</span></div>
          <div className="text-sm pt-5">Mary Dill on <span className="text-gray-900 italic font-semibold"> Another Big Apartment Project Slated for Broad Ripple Company</span></div>
          <div className="text-sm pt-5">Mary Dill on <span className="text-gray-900 italic font-semibold"> Another Big Apartment Project Slated for Broad Ripple Company</span></div>
          <div className="text-sm pt-5">Mary Dill on <span className="text-gray-900 italic font-semibold"> Another Big Apartment Project Slated for Broad Ripple Company</span></div>
          <div className="text-sm pt-5">Mary Dill on <span className="text-gray-900 italic font-semibold"> Another Big Apartment Project Slated for Broad Ripple Company</span></div>
        </div>
      </div>
    </>
  );
};

export default RecentComments;
